import type { ChatRoomResponseLastMessageSenderBasicInfo } from './chatRoomResponseLastMessageSenderBasicInfo';
import type { ChatRoomResponseLastMessageSenderSocial } from './chatRoomResponseLastMessageSenderSocial';

/**
 * 발신자 정보
 */
export type ChatRoomResponseLastMessageSender = {
  /** 사용자 기본 정보 */
  basicInfo: ChatRoomResponseLastMessageSenderBasicInfo;
  /** 소셜 관계 정보 */
  social?: ChatRoomResponseLastMessageSenderSocial;
};
